<template>
  <div class="category-wrap">
    <div
      class="category-content container"
      @mouseover="showProductList=true"
      @mouseout="showProductList=false"
    >
      <div class="category-tab-nav">
        <div
          class="category-item"
          v-for="(item, index) in classList"
          :key="index"
          :class="[
            'category-item--fore'+item.classId,
            {'category-item--active': currentClassId==item.classId}
          ]"
        >
          <h3
            class="category-item__name"
            :class="['category-item__name--fore'+item.classId]"
            @click="handleClassItemClick(item)"
          >
            <span v-text="item.className"></span>
          </h3>
          <ul class="category-item__brand-list">
            <li
              class="category-item__brand-item"
              v-for="(bItem, index) in item.brandList.slice(0, 3)"
              :key="index"
              :class="{'category-item__brand-item--active': currentBrandId==bItem.brandId}"
              @mouseover="handleBrandItemMouseover(bItem)"
            >
              <span v-text="bItem.brandName"></span>
            </li>
            <li class="category-item__brand-item">
              <router-link class="button--brand-more" :to="'/products/'+item.classId">查看更多品牌</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="category-tab-content" v-show="showProductList">
        <ul class="product-list">
          <li class="product-item" v-for="(item, index) in productList.slice(0, 14)" :key="index">
            <img class="product-logo" v-lazy="item.productLogo" :alt="item.productName" :key="item.productLogo"/>
            <h3 class="product-name" v-text="item.productName"></h3>
            <!-- <router-link
              class="product-button"
              :to="{name: 'ProductInfo', params: { productId: item.productId }}"
            >估价</router-link> -->
            <a class="product-button" href="javascript:;" @click="goToEvaluate(item)">估价</a>
          </li>
          <router-link
            class="button--product-more"
            :to="'/products/'+currentClassId+'/'+currentBrandId"
          >更多></router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data () {
    return {
      showProductList: false
    };
  },
  computed: {
    ...mapState({
      classList: state => state.navData.classList,
      currentClassId: state => state.navData.currentClassId,
      currentBrandId: state => state.navData.currentBrandId,
      productList: state => state.navData.product.list
    })
  },
  methods: {
    handleBrandItemMouseover (brand) {
      this.$store.commit('navData/setBrandId', brand.brandId);
      this.$store.dispatch('navData/getProductList');
    },
    handleClassItemClick (category) {
      this.$store.commit('navData/setClassId', category.classId);
      this.$store.commit(
        'navData/setBrandId',
        category.brandList[0]['brandId']
      );
      this.$store.dispatch('navData/getProductList');
    },
    goToEvaluate (item) {
      this.$store.commit('report/reportHandle', { event: 'evaluation' });
      this.$router.push({name: 'ProductInfo', params: { productId: item.productId }});
    }
  },
  watch: {
    productList (val) {
      // console.log(val);
    }
  }
};
</script>

<style lang="css" scoped>
@import "config.css";

.category-wrap,
.category-content {
  position: relative;
  height: 100%;
}

.category-tab-nav {
  z-index: 2;
  position: absolute;
  width: 232px;
  height: 100%;
  background-color: #f8f9fb;
}

.category-tab-content {
  z-index: 2;
  position: absolute;
  left: 232px;
  width: 968px;
  height: 100%;
  background-color: #f8f9fb;
}

.category-item__name {
  background-color: #fff;
}

.category-item__name,
.category-item__brand-item {
  position: relative;
  height: 40px;
  padding-left: 40px;
  font-size: 14px;
  line-height: 40px;
  font-weight: 400;
  cursor: pointer;
  &::after {
    content: " ";
    display: inline-block;
    float: right;
    margin-right: 20px;
    width: 20px;
    height: 40px;
    vertical-align: middle;
    background: url(https://www.huishoubao.com/static/pc/1001/img/7_02.png)
      no-repeat 0 15px;
    -webkit-transition: 0.4s all;
    transition: 0.4s all;
  }
}

.category-item__brand-item {
  &--active {
    color: #333;
    background-color: #fabe00;
  }
}

.category-item__name--fore1::before {
  content: " ";
  display: block;
  width: 13px;
  height: 18px;
  position: absolute;
  top: 12px;
  left: 15px;
  background-image: url(https://www.huishoubao.com/static/pc/1001/img/sprite.png);
  background-position: -93px -52px;
}

.category-item__name--fore2::before {
  content: " ";
  display: block;
  width: 30px;
  height: 18px;
  position: absolute;
  top: 12px;
  left: 10px;
  background-image: url(https://www.huishoubao.com/static/pc/common/img/icon_macbook.png);
  background-repeat: no-repeat;
}

.category-item__name--fore3::before {
  content: " ";
  display: block;
  width: 15px;
  height: 16px;
  position: absolute;
  top: 12px;
  left: 15px;
  background-image: url(https://www.huishoubao.com/static/pc/1001/img/sprite.png);
  background-position: -66px -52px;
}

.category-item__brand-list {
  overflow: hidden;
  height: 0;
  transition: all 300ms;
}

.category-item--active .category-item__brand-list {
  /* height: 280px; */
  height: 160px;
}

.product-list {
  z-index: 2;
  position: relative;
  padding: 20px 0;
  height: 400px;
  background: #fff;
  border: 1px solid #eeeeee;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.product-item {
  position: relative;
  float: left;
  display: table-cell;
  width: 270px;
  height: 70px;
  margin-right: 45px;
  font-size: 12px;
  line-height: 70px;
}

.product-logo {
  width: 25px;
  margin: 0 27px;
  margin-left: 36px;
  vertical-align: middle;
}

.product-name {
  display: inline-block;
  width: 110px;
  height: 12px;
  font-size: 12px;
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-button {
  width: 58px;
  height: 24px;
  line-height: 22px;
  background: #fff;
  float: right;
  color: rgb(241, 83, 64);
  border: 1px solid rgb(240, 19, 0);
  text-align: center;
  margin-top: 23px;
  -webkit-transition: 0.4s all;
  transition: 0.4s all;
  &:hover {
    color: #fff;
    background: #f15340;
  }
}

.button--product-more {
  position: absolute;
  right: 65px;
  bottom: 41px;
  padding: 6px 17px;
  color: #4378fd;
  text-align: center;
  font-size: 14px;
  border: 1px solid #4378fd;
  cursor: pointer;
  &:hover {
    color: #fff;
    background: #4378fd;
  }
}

.button--brand-more {
  color: inherit;
  &:hover {
    color: $active-a-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-category.vue